import {
  Box,
  Stack,
  TextInput,
  MultiSelect,
  NumberInput,
  Button,
  Text,
  Select,
  Group,
} from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { InventoryCategoriesRecord } from '../types/pocketbase-types';
import { useState, useEffect } from 'react';

interface FilterNavbarProps {
  initialNameQuery?: string;
  onNameQueryChange: (value: string) => void;
  localSelectedCategories: string[];
  setLocalSelectedCategories: (value: string[]) => void;
  localSelectedManufacturers: string[];
  setLocalSelectedManufacturers: (value: string[]) => void;
  localSelectedCurrencies: string[];
  setLocalSelectedCurrencies: (value: string[]) => void;
  localPriceRange: [number | null, number | null] | null;
  setLocalPriceRange: (value: [number | null, number | null] | null) => void;
  categoriesQuery: { data?: InventoryCategoriesRecord[] };
  manufacturersQuery: { data?: string[] };
  minMaxPrices?: { min: number; max: number } | null;
  onApplyFilters: () => void;
  resetLocalState: (fn: () => void) => void;
  globalCurrency?: string;
  setGlobalCurrency: (value: string | undefined) => void;
}

export default function FilterNavbar({
  initialNameQuery = '',
  onNameQueryChange,
  localSelectedCategories,
  setLocalSelectedCategories,
  localSelectedManufacturers,
  setLocalSelectedManufacturers,
  localSelectedCurrencies,
  setLocalSelectedCurrencies,
  localPriceRange,
  setLocalPriceRange,
  categoriesQuery,
  manufacturersQuery,
  minMaxPrices,
  onApplyFilters,
  resetLocalState,
  globalCurrency,
  setGlobalCurrency,
}: FilterNavbarProps) {
  const [localNameQuery, setLocalNameQuery] = useState(initialNameQuery);

  const resetAll = () => {
    setLocalNameQuery('');
    setLocalSelectedCategories([]);
    setLocalSelectedManufacturers([]);
    setLocalSelectedCurrencies([]);
    setLocalPriceRange(null);
    setGlobalCurrency(undefined);
  };

  useEffect(() => {
    resetLocalState(resetAll);
  }, [resetLocalState]);

  return (
    <Box p="md">
      <Stack>
        <TextInput
          label="ציוד"
          description="חיפוש לפי שם"
          placeholder="חיפוש..."
          leftSection={<IconSearch size={14} />}
          value={localNameQuery}
          onChange={(e) => {
            setLocalNameQuery(e.currentTarget.value);
          }}
        />

        <MultiSelect
          label="קטגוריות"
          description="סינון לפי קטגוריה"
          data={
            categoriesQuery.data
              ?.map((record) => record.name)
              .filter(Boolean) || []
          }
          value={localSelectedCategories}
          placeholder="בחר קטגוריות..."
          onChange={setLocalSelectedCategories}
          leftSection={<IconSearch size={16} />}
          clearable
          searchable
        />

        <MultiSelect
          label="יצרנים"
          description="סינון לפי יצרן"
          data={manufacturersQuery.data || []}
          value={localSelectedManufacturers}
          placeholder="בחר יצרנים..."
          onChange={setLocalSelectedManufacturers}
          leftSection={<IconSearch size={16} />}
          clearable
          searchable
        />

        {/* <MultiSelect
          label="מטבע"
          description="סינון לפי מטבע"
          data={[
            { value: 'ILS', label: '₪ שקל' },
            { value: 'USD', label: '$ דולר' },
            { value: 'EUR', label: '€ אירו' },
            { value: 'GBP', label: '£ פאונד' },
          ]}
          value={localSelectedCurrencies}
          placeholder="בחר מטבעות..."
          onChange={setLocalSelectedCurrencies}
          leftSection={<IconSearch size={16} />}
          clearable
          searchable
        /> */}

        <Select
          label="מטבע גלובלי"
          description="הצג פריטים עם מטבע זה בכל שדה מחיר"
          data={[
            { value: 'ILS', label: '₪ שקל' },
            { value: 'USD', label: '$ דולר' },
            { value: 'EUR', label: '€ אירו' },
            { value: 'GBP', label: '£ פאונד' },
          ]}
          value={globalCurrency}
          placeholder="בחר מטבע..."
          onChange={(value) => setGlobalCurrency(value || undefined)}
          leftSection={<IconSearch size={16} />}
          clearable
          searchable
        />

        <Box>
          <Text size="sm" fw={500} mb={4}>
            טווח מחירים
          </Text>
          <Text size="xs" c="dimmed" mb="sm">
            סינון לפי מחיר רכישה
          </Text>
          <Group grow gap="xs">
            <NumberInput
              label="מחיר מינימלי"
              value={localPriceRange ? localPriceRange[0] : null}
              min={0}
              max={
                localPriceRange
                  ? (localPriceRange[1] ?? minMaxPrices?.max ?? 999999)
                  : 999999
              }
              onChange={(value) => {
                setLocalPriceRange([
                  value,
                  localPriceRange ? localPriceRange[1] : null,
                ]);
              }}
              allowNegative={false}
              thousandSeparator=","
              hideControls
            />
            <NumberInput
              label="מחיר מקסימלי"
              value={localPriceRange ? localPriceRange[1] : null}
              min={localPriceRange ? (localPriceRange[0] ?? 0) : 0}
              max={minMaxPrices?.max ?? 999999}
              onChange={(value) => {
                setLocalPriceRange([
                  localPriceRange ? localPriceRange[0] : null,
                  value,
                ]);
              }}
              allowNegative={false}
              thousandSeparator=","
              hideControls
            />
          </Group>
        </Box>

        {/* TODO: move this to the footer of the navbar */}
        <Button
          variant="filled"
          onClick={() => {
            onNameQueryChange(localNameQuery);
            onApplyFilters();
          }}
        >
          החל סינון
        </Button>
      </Stack>
    </Box>
  );
}
